/* globals $, Vue, ga, MediaQuery, Modernizr, objectFitImages, Swiper */

/* exported App */

'use strict';

Vue.config.debug = false;

var bus = new Vue();
window.vueBus = bus;

var App = (function() {

    var config = {
            selectors: {
                window: window,
                body: 'body',

                navToggle: '.js-nav-toggle',
                smoothScrolling: '.js-smooth-scroll',

                sidebar: '.js-sidebar',
                sidebarToggle: '.js-sidebar-toggle',

                slideshow: '.js-slideshow',
                slideInner: '.js-slide-inner',
                slideContent: '.js-slide-content',
                slideshowPagination: '.js-slideshow-pagination',

                inlineSlideshow: '.js-inline-slideshow',

                searchToggleLink: '.js-search-toggle-link',
                locationListToggleLink: '.js-location-list-link',
                eventListToggleLink: '.js-event-list-link',

                announcementList: '.js-announcement-list',
                announcement: '.js-announcement',
                announcementClose: '.js-announcement-close',

                popupList: '.js-popup-list',
                popup: '.js-popup',
                popupClose: '.js-popup-close',

                eventTable: '.js-event-table',

                markGrid: '.js-mark-grid',

                measureChild: '.js-measure-child',
                measureTarget: '.js-measure-target',

                marquee: '.js-marquee'
            },

            smoothScrollingSpeed: 600,
            objectFitInterval: 3000,

            // Slideshow settings: optional(disabled) items are prefixed by a _

            slideshowSettings: {
                init: false,
                _autoplay: {
                    delay: 4500,
                },
                _spaceBetween: 15,
                speed: 600,
                loop: false,
                direction: 'horizontal',
                autoHeight: true,
                grabCursor: true,
                mousewheelForceToAxis: true,
                navigation: {
                    prevEl: '.js-slideshow-prev',
                    nextEl: '.js-slideshow-next',
                    disabledClass: 'is-disabled',
                },
            },
        },

        selectors = {},

        elements = {}, $e,



    init = function(_config) {
        // Extend module config
        $.extend(true, config, _config || {});

        // Cache all elements for later use
        cacheElements();

        // DOM and event bindings
        setupBindings();

        // Pub/sub
        setupEvents();

        // Object-fit images
        objectFitPolyfill();

        // Sidebars
        setupSidebars();
        setupSidebarNavigation();

        // Event table
        setupEventTable();

        // Announcements & popups
        setupAnnouncements();
        setupPopups();

        // Scrolling marquees
        setupMarquees();
    },



    cacheElements = function() {
        // Iterate over all selectors in config and store them as jQuery objects
        $.each(config.selectors, function(elementName, selector) {
            elements[elementName] = $(selector);
        });

        // Shortcuts
        selectors = config.selectors;
        $e = elements;
    },


    // DOM bindings
    setupBindings = function() {

        // Toggle mobile navigation
        $(document).on('click', selectors.navToggle, function(event){
            $e.body.toggleClass('is-nav-visible');
            event.preventDefault();
        });

        // Make anchor links scroll smoothly
        $(document).on('click', selectors.smoothScrolling, function(event){
            var $link = $(this),
                $target = $($link.attr('href')),
                scrollTo = $target.offset().top;

            $('html, body').animate({scrollTop: scrollTo}, config.smoothScrollingSpeed);
            event.preventDefault();
        });

        // Resizing? Save to body
        $(window).on('resizestart',   0, function(){ $e.body.addClass('is-resizing'); });
        $(window).on('resizestop', 1000, function(){ $e.body.removeClass('is-resizing'); });

        // Breakpoint change
        $.subscribe('/mediaquery/change', function(_, size) {
            if (MediaQuery.atLeast('small')) {

            }
        });

        // Re-initialize page after ajax page loads
        $(window).on('statechangecomplete', onStateChange);

        // "Fake" state change to initialize everything now
        onStateChange();
    },

    // Observers for interaction with other modules
    setupEvents = function() {
        // Show and hide loading spinner when loading over Ajax
        $.subscribe('/ajax/start', function() { $e.body.addClass('is-loading'); });
        $.subscribe('/ajax/stop',  function() { $e.body.removeClass('is-loading'); });

        // Log all ajax errors to console
        $(document).ajaxError(function(event, jqXHR, settings, error) {
            console.error('Ajax request failed: ' + error + ' ('+settings.url+')');
        });
    },

    onStateChange = function() {
        setupMarkGrid();
        setupMeasureChild();
        setupSlideshows();
        openExternalLinksInNewTab();
    },

    pageHasTemplate = function(template) {
        return $e.body.hasClass('template-' + template);
    },




    trackCustomEvent = function(category, action, label){
        ga('send', 'event', category, action, label);
    },

    objectFitPolyfill = function () {
        if (Modernizr.objectfit) {
            return;
        }

        if (typeof objectFitImages !== 'function') {
            return;
        }

        var triggerObjectFit = function () {
            objectFitImages(null, {watchMQ: true});
        };

        triggerObjectFit();
        setTimeout(triggerObjectFit, config.objectFitInterval / 2);
        setInterval(triggerObjectFit, config.objectFitInterval);
    },

    openExternalLinksInNewTab = function () {
        $('a')
            .filter('[href^="http"], [href^="//"]')
            .not('[href*="' + window.location.host + '"]')
            .attr('rel', 'noopener noreferrer')
            .attr('target', '_blank');
    },

    numOpenSidebars = function () {
        return $e.sidebar.filter('.is-open').length;
    },

    hasOpenSidebars = function () {
        return numOpenSidebars() >= 1;
    },

    markOpenSidebars = function () {
        $e.body.toggleClass('is-sidebar-open', hasOpenSidebars());
    },

    setupSidebars = function () {
        if (MediaQuery.atLeast('xlarge')) {
            $e.sidebar.filter('.is-initially-open').addClass('is-open');
        }
        $e.sidebar.removeClass('is-initially-open');

        markOpenSidebars();

        $(document).on('click', selectors.sidebarToggle, function(event){
            event.preventDefault();

            var $sidebar = $(this).closest(selectors.sidebar),
                sidebarName = $sidebar.data('sidebar-name');

            toggleSidebar($sidebar);
        });
    },

    setupSidebarNavigation = function () {
        var markNavItemActive = function(target) {
            var $li = $(target).closest('li'),
                $lis = $li.siblings();
            $lis.removeClass('is-active');
            $li.addClass('is-active');
        };

        $e.searchToggleLink.click(function(event){
            event.preventDefault();
            openSidebar('search');
        });
    },

    openSidebar = function (sidebar) {
        var $sidebar = getSidebar(sidebar);
        $sidebar.addClass('is-open');
        // Close all others
        $e.sidebar.not($sidebar).removeClass('is-open');
        markOpenSidebars();
    },

    toggleSidebar = function (sidebar) {
        var $sidebar = getSidebar(sidebar);
        $sidebar.toggleClass('is-open');
        // Close all others
        $e.sidebar.not($sidebar).removeClass('is-open');
        markOpenSidebars();
    },

    closeSidebar = function (sidebar) {
        var $sidebar = getSidebar(sidebar);
        $sidebar.removeClass('is-open');
        markOpenSidebars();
    },

    getSidebar = function (sidebar) {
        return sidebar instanceof jQuery ? sidebar : $e.sidebar.filter('[data-sidebar-name="'+sidebar+'"]');
    },

    setupEventTable = function () {
        if (!$e.eventTable.length) return;

    },

    setupAnnouncements = function () {
        // Abort if the page has no announcements
        if (!$e.announcementList.length) return;

        // Abort if the user has navigated here from another page on the site
        // i.e. only display announcements on the first pageview of the session
        if (document.referrer.indexOf(window.location.hostname) !== -1) return;

        $e.announcementList.addClass('is-setup');
        $e.announcement.last().addClass('is-last-open');

        // Close on click on background
        $e.announcementList.click(function(event){
            if (event.target === this) {
                close(true);
            }
        });

        // CLose on click on close button
        $e.announcementClose.click(function(event){
            var $announcement = $(this).closest(selectors.announcement);
            $announcement.addClass('is-closed');
            close();
        });

        var close = function(closeAll) {
            var $open = $e.announcement.filter(':not(.is-closed)');
            $open.last().addClass('is-last-open');
            if ($open.length === 0) {
                $e.announcementList.removeClass('is-setup');
            }
            var $contentopen = $open.filter('[data-has-content="true"]');
            if ($contentopen.length === 0 || closeAll) {
                var numOpen = $open.length;
                $open.each(function(i) {
                    var index = numOpen - i;
                    var $item = $(this);
                    setTimeout(function() {
                        $item.addClass('is-closed');
                    }, index * 250);
                });
                setTimeout(function() {
                    $e.announcementList.removeClass('is-setup');
                }, numOpen * 500);
            }
        };
    },

    setupPopups = function () {
        // Abort if the page has no popups
        if (!$e.popup.length) return;

        // Close button
        $e.popupClose.click(function(event){
            var $popup = $(this).closest(selectors.popup);
            $popup.addClass('is-closed');
        });
    },

    setupMarquees = function () {
        // Abort if the page has no marquees
        if (!$e.marquee.length) return;

        nodeMarquee({
            selector: selectors.marquee,
            pauseOnHover: false,
            prependWhitespace: false,
            optimizeCalculation: true,
            speed: 3
        });
    },

    setupMeasureChild = function () {
        var $newEls = $(selectors.measureChild).filter(function() {
            return $(this).data('setup') !== true;
        });

        $newEls.each(function() {
            var target = this.closest(selectors.measureTarget) || el;

            const observer = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    const width = entry.contentRect.left + entry.contentRect.width + entry.contentRect.left;
                    target.style.setProperty('--child-width', Math.floor(width) + 'px');
                }
            });

            observer.observe(this);
        })
        .data('setup', true);
    },

    setupMarkGrid = function () {
        var $newEls = $(selectors.markGrid).filter(function() {
            return $(this).data('setup') !== true;
        });

        $newEls.each(function() {
            const mark = () => detectGrid.markGrid(this)
            const observer = new ResizeObserver(() => mark());
            observer.observe(this);
        })
        .data('setup', true);
    },

    setupSlideshows = function () {
        var $newSlideshows = $(selectors.slideshow).filter(function() {
            return $(this).data('setup') !== true;
        });

        $newSlideshows.each(function(){
            var $slideshow = $(this),
                slideNum = $slideshow.find('.swiper-slide').length,
                slideshowConfig = $.extend({}, config.slideshowSettings);

            // Leave untouched for single slides
            if (slideNum < 2) {
                return;
            }

            if ($slideshow.is('[data-autoplay]')) {
                slideshowConfig.autoplay = slideshowConfig._autoplay;
            }
            if ($slideshow.is('[data-loop]')) {
                slideshowConfig.loop = true;
                slideshowConfig.loopAdditionalSlides = slideNum;
            }
            if ($slideshow.is('[data-height-fixed]')) {
                slideshowConfig.autoHeight = false;
            }
            if ($slideshow.is('[data-space-between]')) {
                slideshowConfig.spaceBetween = slideshowConfig._spaceBetween;
            }
            if ($slideshow.is('[data-direction="vertical"]')) {
                slideshowConfig.direction = 'vertical';
                slideshowConfig.mousewheel = true;
                slideshowConfig.slidesPerView = 'auto';
                slideshowConfig.freeMode = 'auto';
                // slideshowConfig.freeModeMomentum = false;
                slideshowConfig.freeModeMomentumRatio = 0.3;
                slideshowConfig.freeModeMomentumVelocityRatio = 2;
                slideshowConfig.freeModeSticky = true;
            }

            var swiperInstance = new Swiper(this, slideshowConfig);
            var initial = true;
            swiperInstance.on('slideChange', function () {
                if (!initial) {
                    $slideshow.addClass('was-changed');
                }
                $slideshow.find('.lazyloading:not(.lazyload)').removeClass('lazyloading').removeClass('lazyloaded').addClass('lazyload');
                initial = false;
            });

            swiperInstance.init();

            $slideshow.addClass('is-setup');

        })
        .data('setup', true);
    };

    // Public properties and methods
    return {
        init: init,
    };

})();

// General site/app module

$(function() {

    // Initialize media query detection

    MediaQuery.init();

    // Load up app and initialize

    App.init();

});
